import { convertStyle } from 'utils/Style';
import { formatDateStringForMinute } from 'utils/Common';
import { ApiPromotionGetMissionEvent } from 'api/Promotion';

import promotionStyle from '../style/Promotion.module.scss';
import missionStyle from '../style/MissionEvent.module.scss';

import img_misson_like_icon from 'assets/images/promotion/mission_like_icon.png';
import img_stamp_off from 'assets/images/promotion/stamp_off.png'
import img_stamp_on from 'assets/images/promotion/stamp_on.png'
import NewlineToBr from 'component/common/content/NewlineToBr';
import { useBookpalNavigate, getNbpLink } from 'component/common/custom/BookpalLink';
import useAlertSuccessModal from 'component/common/modal/useAlertSuccessModal';
import { useState } from 'react';
import { isApp } from 'utils/AppUtil';


const style = { ...promotionStyle, ...missionStyle };



function Mission({index, data}){

    const navigate = useBookpalNavigate();

    const [_data, setData] = useState(data);

    const [AlertSuccessModal, successAlert] = useAlertSuccessModal();

    const getMissionEventSubmit = ApiPromotionGetMissionEvent({
        onSuccess:(data)=>{
            if(data?.status === true){
                successAlert("선물이 지급되었습니다.\n미션 성공을 축하합니다!","이제 다른 미션도 도전해보세요!");
                // const result = _data?.result;
                setData({..._data, receive_yn:"Y"});
                return;
            }
        },
        onError:(e)=>{

        }
    });

    return (
        <div key={index} className={convertStyle(style, "list_item temp_misson radius-xxl white-always bg")}>
            <div className={convertStyle(style, "con_box")}>
                <div className={convertStyle(style, "missonDesc")}>
                    <div className={convertStyle(style, "left")}>
                        <p className={convertStyle(style, "missonNum")}>
                            <span className={convertStyle(style, "radius-full color-state-point-01 txt border border-soild")}>
                                MISSION {index+1}
                            </span>
                        </p>
                        <p className={convertStyle(style, "title display-01-long black-always txt")}>
                            {_data?.title}
                        </p>
                        <p className={convertStyle(style, "desc body-03-long")}>
                            <NewlineToBr text={_data?.info} />
                        </p>
                        {_data?.link ?
                        <p className={convertStyle(style, "more_button")}>
                            <button 
                                type="button" 
                                className={convertStyle(style, "button label_on medium radius-full")}
                                data-link={_data?.link}
                                onClick={(e)=>{
                                    const link = e.currentTarget.getAttribute("data-link");
                                    if(isApp()){
                                        navigate(link); 
                                        return;
                                    }
                                    window.open(getNbpLink(link), '');
                                }}
                                >
                                <span className="btn-03">자세히 보기</span>
                            </button>
                        </p>
                        :null}
                    </div>
                    <div className={convertStyle(style, "right")}>
                        <div className={convertStyle(style, "misson_circle")}>
                            <div className={convertStyle(style, "misson_con radius-full misson_num")}>
                                {/* <div className={convertStyle(style, "missonBage")}>
                                    <img src={img_stamp_off} />
                                </div> */}
                                {/* <div className={convertStyle(style, "missonBage")}>
                                    <img src={img_stamp_on} />
                                </div> */}
                                <div className={convertStyle(style, "missonRate")}>
                                    <p className={convertStyle(style, "top display-01")}>
                                    {_data?.current_value}
                                    </p>
                                    <p className={convertStyle(style, "bottom title-02-b")}>
                                    {_data?.mission_value}
                                    </p>
                                </div>
                            </div>
                            {_data?.success_yn === "Y"?
                            <div className={convertStyle(style, "missonIcon radius-full")}>
                                <img src={img_misson_like_icon} />
                            </div>
                            :null}
                        </div>
                        {(()=>{
                            
                            if(_data?.success_yn === "Y"){
                                switch(_data?.reword_type){
                                    case "auto":
                                        return (
                                            <p className={convertStyle(style, "misson_text")}>
                                                <span className={convertStyle(style, "button label_on medium text btn-03")}>선물 지급 완료!</span>
                                            </p>
                                        );
                                    case "manual":
                                        if(_data?.receive_yn === "Y"){
                                            return (
                                                <p className={convertStyle(style, "misson_text")}>
                                                    <span className={convertStyle(style, "button label_on medium text btn-03")}>선물 지급 완료!</span>
                                                </p>
                                            );
                                        } else {
                                            return (
                                                <p className={convertStyle(style, "misson_text")}>
                                                    <button 
                                                        type="button" 
                                                        className={convertStyle(style, "button filled medium label_on radius-full")} 
                                                        data-mission_id={_data?.mission_id}
                                                        data-mission_status={_data?.mission_status}
                                                        onClick={(e)=>{
                                                            const mission_id = e.currentTarget.getAttribute("data-mission_id");
                                                            const mission_status = e.currentTarget.getAttribute("data-mission_status");

                                                            if(mission_status !== "progress"){
                                                                return;
                                                            }

                                                            //선물받기 구현
                                                            getMissionEventSubmit({
                                                                mission_id:mission_id,
                                                            });
                                                        }}
                                                        >
                                                        <span className={convertStyle(style, "btn-03 white-always txt")}>선물받기</span>
                                                    </button>
                                                </p>
                                            );
                                        }
                                    case "draw":
                                        return (
                                            <p className={convertStyle(style, "misson_text")}>
                                                <span className={convertStyle(style, "button label_on medium text btn-03")}>추첨 공지를 확인해주세요~!</span>
                                            </p>
                                        );
                                }
                            } else {
                                if(_data?.mission_per >= 50){
                                    return (
                                        <p className={convertStyle(style, "misson_text")}>
                                            <span className={convertStyle(style, "button label_on medium text btn-03")}>조금만 더 힘내세요~!</span>
                                        </p>
                                    )
                                }
                                if(_data?.current_value === 0){
                                    return (
                                        <p className={convertStyle(style, "misson_text")}>
                                            <span className={convertStyle(style, "button label_on medium text btn-03")}>미션을 시작해보세요!</span>
                                        </p>
                                    )
                                }
                            }
                            return false;
                        })()}
                        
                    </div>
                    {/* {false ?
                    <div className={convertStyle(style, "right")}>
                        <div className={convertStyle(style, "misson_circle")}>
                            <div className={convertStyle(style, "misson_con misson_icon radius-full icon_img")}>
                                <div className={convertStyle(style, "missonBage")}>
                                    <img src={img_stamp_off} />
                                </div>
                            </div>
                        </div> 
                        <p className={convertStyle(style, "misson_text")}>
                            <span className={convertStyle(style, "button label_on medium text btn-03")}>
                            미션을 시작해보세요!
                            </span>
                        </p>
                    </div>
                    : null} */}
                </div>
                <div className={convertStyle(style, "missonInfo radius-sm")}>
                    <div className={convertStyle(style, "info_left")}>
                        <p className={convertStyle(style, "text title-book-02-m")}>리워드</p>
                        <p className={convertStyle(style, "date title-book-02-m")}>
                            <span>{_data?.voucher_type === "own"?"선물소장권":"선물이용권"}</span>
                            <span className={convertStyle(style, "title-book-02-b ml_4")} >{_data?.voucher_cnt}</span>장
                        </p>
                    </div>
                    <div className={convertStyle(style, "info_right")}>
                        <p className={convertStyle(style, "text title-book-02-m")}>참여기간</p>
                        <p className={convertStyle(style, "date title-book-02-m")}>
                            <span>{formatDateStringForMinute(_data?.start_date)}</span>
                            <span className={convertStyle(style, "ph_4")} >~</span>
                            <span>{formatDateStringForMinute(_data?.end_date)}</span>
                        </p>
                    </div>
                </div>
            </div>
            {_data?.mission_status === "wait"?
            <div className={convertStyle(style, "dimmed bg black_opacity-30")}>
                <p className={convertStyle(style, "text txt white-always radius-full black_opacity-50")}>
                    미션 오픈 전입니다.
                </p>
            </div>
            :null}
            {_data?.mission_status === "end"?
            <div className={convertStyle(style, "dimmed bg black_opacity-30")}>
                <p className={convertStyle(style, "text txt white-always radius-full black_opacity-50")}>
                    종료된 미션입니다.
                </p>
            </div>
            :null}
            {/* <div className={convertStyle(style, "dimmed bg black_opacity-30")}>
                <p className={convertStyle(style, "text txt white-always radius-full black_opacity-50")}>
                    미션 오픈 전입니다.
                    종료된 미션입니다.
                </p>
            </div> */}
            <AlertSuccessModal />
        </div>
    )
}


export default Mission;